// Versione applicativa e data ultima modifica, mostrate nell'interfaccia.
// Aggiornare a OGNI rilascio.
export const APP_VERSION = "1.0.0";
export const LAST_UPDATED = "15/06/2026";
